export default "__VITE_ASSET__BwBqw$h1__"